export enum EEnvironment {
  PROD = 'content.adireto.com',
  STAGING = 'content-staging.adireto.com',
  LOCAL = 'localhost',
}

export const getSystemIdentity = (hostname: EEnvironment) => {
  const applicationURI: Record<EEnvironment, string> = {
    [EEnvironment.PROD]: 'https://content.adireto.com',
    [EEnvironment.STAGING]: 'https://content-staging.adireto.com',
    [EEnvironment.LOCAL]: 'http://localhost:3000',
  };

  const authHost: Record<EEnvironment, string> = {
    [EEnvironment.PROD]: 'https://auth.adireto.com',
    [EEnvironment.STAGING]: 'http://auth-staging.adireto.com',
    [EEnvironment.LOCAL]: 'http://auth-staging.adireto.com',
  };

  const redirect: Record<EEnvironment, string> = {
    [EEnvironment.PROD]: 'https://content.adireto.com',
    [EEnvironment.STAGING]: 'https://content-staging.adireto.com',
    [EEnvironment.LOCAL]: 'http://localhost:3000',
  };

  return {
    isProduction: hostname === EEnvironment.PROD,
    applicationURI,
    authHost,
    redirect,
  };
};
